/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarDto } from '../model';
// @ts-ignore
import type { PaginatedRequest } from '../model';
// @ts-ignore
import type { PaginatedResponseCar } from '../model';
/**
 * PublicCarControllerApi - axios parameter creator
 * @export
 */
export const PublicCarControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a car by ID (Public)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            const localVarPath = `/api/v1/public/car/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest added cars (Top 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/public/car/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated car (Public)
         * @param {PaginatedRequest} paginatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated: async (paginatedRequest: PaginatedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paginatedRequest' is not null or undefined
            assertParamExists('getPaginated', 'paginatedRequest', paginatedRequest)
            const localVarPath = `/api/v1/public/car/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paginatedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicCarControllerApi - functional programming interface
 * @export
 */
export const PublicCarControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicCarControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a car by ID (Public)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicCarControllerApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get latest added cars (Top 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicCarControllerApi.getLatest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated car (Public)
         * @param {PaginatedRequest} paginatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginated(paginatedRequest: PaginatedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseCar>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginated(paginatedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicCarControllerApi.getPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicCarControllerApi - factory interface
 * @export
 */
export const PublicCarControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicCarControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a car by ID (Public)
         * @param {PublicCarControllerApiGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(requestParameters: PublicCarControllerApiGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CarDto> {
            return localVarFp.get(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest added cars (Top 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatest(options?: RawAxiosRequestConfig): AxiosPromise<Array<CarDto>> {
            return localVarFp.getLatest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated car (Public)
         * @param {PublicCarControllerApiGetPaginatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated(requestParameters: PublicCarControllerApiGetPaginatedRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseCar> {
            return localVarFp.getPaginated(requestParameters.paginatedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for get operation in PublicCarControllerApi.
 * @export
 * @interface PublicCarControllerApiGetRequest
 */
export interface PublicCarControllerApiGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicCarControllerApiGet
     */
    readonly id: string
}

/**
 * Request parameters for getPaginated operation in PublicCarControllerApi.
 * @export
 * @interface PublicCarControllerApiGetPaginatedRequest
 */
export interface PublicCarControllerApiGetPaginatedRequest {
    /**
     * 
     * @type {PaginatedRequest}
     * @memberof PublicCarControllerApiGetPaginated
     */
    readonly paginatedRequest: PaginatedRequest
}

/**
 * PublicCarControllerApi - object-oriented interface
 * @export
 * @class PublicCarControllerApi
 * @extends {BaseAPI}
 */
export class PublicCarControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get a car by ID (Public)
     * @param {PublicCarControllerApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicCarControllerApi
     */
    public get(requestParameters: PublicCarControllerApiGetRequest, options?: RawAxiosRequestConfig) {
        return PublicCarControllerApiFp(this.configuration).get(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest added cars (Top 10)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicCarControllerApi
     */
    public getLatest(options?: RawAxiosRequestConfig) {
        return PublicCarControllerApiFp(this.configuration).getLatest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated car (Public)
     * @param {PublicCarControllerApiGetPaginatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicCarControllerApi
     */
    public getPaginated(requestParameters: PublicCarControllerApiGetPaginatedRequest, options?: RawAxiosRequestConfig) {
        return PublicCarControllerApiFp(this.configuration).getPaginated(requestParameters.paginatedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

